import React from 'react';


import "@fontsource/mulish"; // Defaults to weight 400.



import {  Switch, Route} from 'react-router-dom';

import Home from './Home'; 
import AllData from './AllData'; 




function Main() {
  

  return (  

    
    
    <div>
      
        <Switch>
          <Route exact path='/' component={Home}></Route>
          <Route exact path='/Home' component={Home}></Route>         
          <Route exact path='/AllData' component={AllData}></Route>
         
        </Switch>

    </div>

    

  );
}






export default Main;
